import { configureStore } from '@reduxjs/toolkit';

import rootReducers from './reducers';

export default function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: rootReducers,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActionPaths: ['payload.resolveCallback', 'payload.rejectCallback'],
        },
      }),
  });

  return store;
}
